import withResources from './withResources';
export {withResources};



// WEBPACK FOOTER //
// ./app/lib/redux/index.js